import { h, render } from 'preact'

import ImpactState from './components/ImpactState'

const Application = {
  start (props) {
    render(h(ImpactState, props), document.body,
      document.querySelector('.widget'))
  }
}

export default Application
